import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useMemo } from 'react';
import { useDispatch, useSelector, useStore } from 'react-redux';
import invariant from 'invariant';
import * as DataActions from '../../store/data/actions';
import DataPathContext from '../DataPathContext';
import { useDataActions } from '../../hooks/useDataActions';
const EMPTY_ARRAY = [];
export const DetachedRow = (props)=>{
    const { id, children, initialRow } = props;
    const store = useStore();
    if (process.env.NODE_ENV !== 'production') {
        invariant(id, 'id prop is missing.');
        invariant(initialRow, 'initialRow prop is missing.');
        invariant(store.getState().detachedRow, `detachedRow is missing in the redux store. Make sure you are using detachedRowReducer, e.g.

import { configureStore } from '@reduxjs/toolkit';
import { detachedRowReducer } from '@cancercentrum/rcc-react';

const store = configureStore({
    reducer:
        detachedRow: detachedRowReducer,
    },
});
`);
    }
    const getState = useCallback((state)=>{
        return state.detachedRow[id];
    }, [
        id
    ]);
    const dispatch = useDispatch();
    const detachedState = useSelector(getState);
    useEffect(()=>{
        dispatch(DataActions.initDetachedRow(id, initialRow));
        return ()=>{
            dispatch(DataActions.removeDetachedRow(id));
        };
    }, [
        id,
        initialRow,
        dispatch
    ]);
    const dataPathCtx = useMemo(()=>{
        return {
            detachedId: id,
            path: EMPTY_ARRAY
        };
    }, [
        id
    ]);
    const dataActions = useDataActions(EMPTY_ARRAY, id);
    const validate = (options)=>{
        if (!detachedState) {
            throw new Error('Validate cannot be run when the row is undefined.');
        }
        const errors = detachedState.present.getErrors({
            includePristine: true,
            ...options?.getErrorsOptions
        });
        if (errors.length) {
            dataActions.updateRow((r)=>r.markInvalidEntriesAsDirty());
        }
        // Lite confusing men getErrors returnerar RegvarModel eller fel från ValidationGroup.
        return !errors.filter((x)=>{
            return x.$errors.some((y)=>y.isFatal);
        }).length;
    };
    const reset = ()=>{
        dispatch(DataActions.removeDetachedRow(id));
        dispatch(DataActions.initDetachedRow(id, initialRow));
    };
    if (!detachedState) {
        return null;
    }
    return /*#__PURE__*/ _jsx(DataPathContext.Provider, {
        value: dataPathCtx,
        children: children({
            dataActions,
            row: detachedState.present,
            history: detachedState.past,
            validate,
            reset
        })
    });
};
